import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getPortalUrl(type: 'quote' | 'invoice' | 'bill' | 'purchase-order', id: string) {
  const envUrl = (process.env as any).APP_URL;
  const baseUrl = (envUrl && !envUrl.includes('aistudio.google.com')) 
    ? envUrl 
    : window.location.origin;
    
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  // The hash route is intentionally public: the portal fetches the document
  // through /api/public/documents without requiring the client's login.
  return `${cleanBaseUrl}/#/portal/${type}/${encodeURIComponent(id)}`;
}
